import type React from 'react';

import { EVENT_ENUMS } from '@vlabs/api-bindings/src/luna-client/constants';
import { PantsIcon } from '@vlabs/icons';
import type { WithDataTestid, WithClassNameProp } from '@vlabs/uikit/types';
import { useTranslation } from 'react-i18next';

import { AttributeCard } from './attribute-card/AttributeCard';

interface LowerBodyAttributeCardProps extends WithDataTestid, WithClassNameProp {
  values: {
    lower_garment: {
      type: string;
      colors: string[];
    };
  };
}

export function LowerBodyAttributeCard({
  values: { lower_garment },
  className = undefined,
  'data-testid': dataTestId = 'LowerBodyAttributeCard',
  ...props
}: LowerBodyAttributeCardProps): React.JSX.Element {
  const { t } = useTranslation();

  const { type, colors } = lower_garment;

  const description = EVENT_ENUMS.LOWER_BODY.LOWER_GARMENT.TYPE?.[type]?.label;

  const colorsConfig = colors.map((color) => {
    return { color, tooltip: EVENT_ENUMS.LOWER_BODY.LOWER_GARMENT.COLORS[color]?.label };
  });

  return (
    <AttributeCard
      className={className}
      colorsConfig={colorsConfig}
      data={type === 'undefined' ? null : type}
      data-testid={dataTestId}
      description={description}
      icon={<PantsIcon />}
      title={t('shared:attribute_cards.lower_body.title')}
      {...props}
    />
  );
}
